import { P as v, b as d, A as h, s as _, n as o, t as O } from "./element-CV9utnHJ.js";
import { r as w } from "./state-l4hGZdFJ.js";
import { o as m } from "./if-defined-rXcLNTzN.js";
import { c as $ } from "./repeat-DnlRNf63.js";
import { e as k } from "./class-map-3ADKve8g.js";
import { u as S } from "./utils-DznhwRXm.js";
const F = (e, t) => t && (e.find((s) => s.value === t) || e.find((s) => s.label === t)) || null, H = (e, t) => {
  if (!t) return -1;
  const s = e.findIndex((i) => i.value === t);
  return s >= 0 ? s : e.findIndex((i) => i.label === t);
}, I = (e, t) => {
  if (!t) return [...e];
  const s = t.toLowerCase();
  return e.filter((i) => (i.fulltext || i.value + (i.label || "") + (i.prefix || "")).toLowerCase().includes(s));
}, z = (e) => e.value + (e.label || "") + (e.prefix || ""), N = (e, t) => t !== null && e >= t, j = (e, t) => {
  if (!t) return { filtered: [...e], suggestion: null };
  const s = t.toLowerCase(), i = e.filter((l) => {
    var c;
    return (c = l.fulltext) == null ? void 0 : c.toLowerCase().includes(s);
  }), a = i.find(
    (l) => {
      var c;
      return !l.selected && ((c = l.label) == null ? void 0 : c.toLowerCase().startsWith(s));
    }
  ) || null;
  return { filtered: i, suggestion: a };
}, W = (e, t, s, i) => {
  if (!e.trim())
    return { addValueText: null, userInfoMessage: "" };
  const a = e.trim().toLowerCase(), l = t.find((p) => p.toLowerCase() === a), c = s.filter(
    (p) => {
      var b;
      return ((b = p.label) == null ? void 0 : b.toLowerCase().includes(a)) || p.value.toLowerCase().includes(a);
    }
  ), y = c.find(
    (p) => {
      var b;
      return ((b = p.label) == null ? void 0 : b.toLowerCase()) === a || p.value.toLowerCase() === a;
    }
  );
  return (c.length === 0 || !y) && i ? { addValueText: e, userInfoMessage: "" } : c.length === 0 && !i ? { addValueText: null, userInfoMessage: "Ingen treff i søket" } : l ? { addValueText: null, userInfoMessage: "Verdien er allerede valgt" } : { addValueText: null, userInfoMessage: "" };
}, C = (e) => /^[\p{L} ]$/u.test(e), L = (e = 500) => {
  let t = "", s;
  return { append: (l) => (t += l.toLowerCase(), s !== void 0 && clearTimeout(s), s = setTimeout(() => {
    t = "";
  }, e), t), reset: () => {
    t = "", s !== void 0 && (clearTimeout(s), s = void 0);
  }, getBuffer: () => t };
}, M = (e, t) => {
  const s = t.toLowerCase();
  return e.findIndex((i) => {
    var a;
    return (a = i.textContent) == null ? void 0 : a.trim().toLowerCase().startsWith(s);
  });
}, u = (e) => {
  e.scrollIntoView({ block: "nearest" }), window.setTimeout(() => e.focus(), 0);
}, f = (e) => Array.from(
  e.querySelectorAll('[role="option"]:not([data-disabled])') || []
), E = (e) => {
  const t = e.nextElementSibling;
  t && u(t);
}, T = (e, t, s) => {
  const i = e.previousElementSibling;
  if (e.dataset.index === "0" && s) {
    const a = t.querySelector('[role="searchbox"]');
    a && u(a);
  } else i && u(i);
}, x = (e) => {
  const t = f(e);
  t[0] && u(t[0]);
}, g = (e) => {
  const t = f(e), s = t[t.length - 1];
  s && u(s);
}, U = (e, t) => {
  if (t.disabled) return;
  const s = f(e);
  if (t.allowUserInput && t.customUserInput) {
    const a = e.querySelector('[data-type="new-option"]');
    if (a) {
      u(a);
      return;
    }
  }
  const i = s.find((a) => a.dataset.selected === "true");
  if (i) {
    u(i);
    return;
  }
  if (t.includeSearch && !(document.activeElement instanceof HTMLInputElement)) {
    const a = e.querySelector('[role="searchbox"]');
    if (a) {
      window.setTimeout(() => a.focus(), 0);
      return;
    }
  }
  s[0] && u(s[0]);
};
var V = Object.defineProperty, B = Object.getOwnPropertyDescriptor, r = (e, t, s, i) => {
  for (var a = i > 1 ? void 0 : i ? B(t, s) : t, l = e.length - 1, c; l >= 0; l--)
    (c = e[l]) && (a = (i ? c(t, s, a) : c(a)) || a);
  return i && a && V(t, s, a), a;
};
let n = class extends v {
  constructor() {
    super(...arguments), this.id = S(), this.label = null, this.options = [], this.isOpen = !1, this.disabled = !1, this.includeSearch = !1, this.isMultiSelect = !1, this.allowUserInput = !1, this.maxIsReached = !1, this.customUserInput = null, this.searchPlaceholder = null, this.searchValue = null, this.maxLength = 0, this.userMessage = null, this._selectedOptions = 0, this.typeahead = L(), this._filteredOptions = [];
  }
  // Lifecycle methods
  connectedCallback() {
    super.connectedCallback(), this.includeSearch && !this.searchValue && (this.searchValue = ""), this.options.length > 0 && this.filterOptions(), this.setAttribute("tabindex", "-1"), this.addEventListener("focus", this.focusFirstOrSelectedOption);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.typeahead.reset();
  }
  updated(e) {
    (e.has("options") || e.has("searchValue")) && this.filterOptions(), super.updated(e);
  }
  attributeChangedCallback(e, t, s) {
    (e === "options" || e === "search-value") && this.filterOptions(), super.attributeChangedCallback(e, t, s);
  }
  // Render methods
  get _hasOptions() {
    return this._filteredOptions.length > 0 || this.options.length > 0;
  }
  render() {
    return d`
      <div
        class=${k({
      "pkt-listbox": !0,
      "pkt-listbox__open": this.isOpen,
      "pkt-txt-16-light": !0
    })}
        role=${m(this._hasOptions ? "listbox" : void 0)}
        aria-multiselectable=${m(
      this._hasOptions && this.isMultiSelect ? "true" : void 0
    )}
        aria-label=${m(this._hasOptions ? this.label ?? void 0 : void 0)}
      >
        <div class="pkt-listbox__banners">
          ${this.renderSearch()} ${this.renderMaximumReachedBanner()} ${this.renderUserMessage()}
          ${this.renderEmptyMessage()} ${this.renderNewOptionBanner()}
        </div>
        <ul class="pkt-listbox__options" role="presentation">
          ${this.renderList()}
        </ul>
      </div>
      <div aria-live="polite" class="pkt-visually-hidden">${this.userMessage}</div>
    `;
  }
  renderCheckboxOrCheckIcon(e, t) {
    return this.isMultiSelect ? d`
          <input
            class="pkt-input-check__input-checkbox"
            type="checkbox"
            role="presentation"
            tabindex="-1"
            value=${e.value}
            .checked=${e.selected}
            aria-labelledby=${this.id + "-option-label-" + t}
            ?disabled=${this.disabled || e.disabled || this.maxIsReached && !e.selected}
          />
        ` : e.selected ? d`<pkt-icon name="check-big"></pkt-icon>` : h;
  }
  renderEmptyMessage() {
    return this.options.length > 0 || this._filteredOptions.length > 0 || this.userMessage ? h : d`<div class="pkt-listbox__banner pkt-listbox__banner--empty">
      <pkt-icon class="pkt-listbox__banner-icon" name="exclamation-mark-circle" size="large"></pkt-icon>
      Tom liste
    </div>`;
  }
  renderList() {
    return d`
      ${$(
      this._filteredOptions,
      (e) => e.value,
      (e, t) => d`
          <li
            @click=${() => {
        this.toggleOption(e);
      }}
            aria-selected=${e.selected ? "true" : "false"}
            @keydown=${this.handleOptionKeydown}
            class=${k({
        "pkt-listbox__option": !0,
        "pkt-listbox__option--selected": !!(!this.isMultiSelect && e.selected),
        "pkt-listbox__option--checkBox": this.isMultiSelect
      })}
            tabindex="${this.disabled || e.disabled ? "-1" : "0"}"
            data-index=${t}
            data-value=${e.value}
            data-selected=${e.selected ? "true" : "false"}
            ?data-disabled=${this.disabled || e.disabled || this.maxIsReached && !e.selected}
            aria-disabled=${this.disabled || e.disabled || this.maxIsReached && !e.selected ? "true" : "false"}
            role="option"
            id=${`${this.id}-${t}`}
          >
            ${this.renderCheckboxOrCheckIcon(e, t)}
            <span class="pkt-listbox__option-label" id=${this.id + "-option-label-" + t}>
              ${e.prefix ? d`<span class="pkt-listbox__option-prefix">${e.prefix}</span>` : h}
              ${e.label || e.value}
            </span>
            ${e.description ? d`<span class="pkt-listbox__option-description pkt-txt-14-light"
                  >${e.description}</span
                >` : h}
          </li>
        `
    )}
    `;
  }
  renderNewOptionBanner() {
    return this.allowUserInput && this.customUserInput ? d`
          <div
            class="pkt-listbox__banner pkt-listbox__banner--new-option pkt-listbox__option"
            data-type="new-option"
            data-value=${this.customUserInput}
            data-selected="false"
            tabindex="0"
            @click=${() => this.toggleOption({
      value: this.customUserInput || ""
    })}
            @keydown=${this.handleOptionKeydown}
          >
            <pkt-icon class="pkt-listbox__banner-icon" name="plus-sign" size="large"></pkt-icon>
            Legg til "${this.customUserInput}"
          </div>
        ` : h;
  }
  renderMaximumReachedBanner() {
    return this._selectedOptions = this.options.filter((e) => e.selected).length, this.isMultiSelect && this._selectedOptions > 0 && this.maxLength > 0 ? d`
          <div class="pkt-listbox__banner pkt-listbox__banner--maximum-reached">
            ${this._selectedOptions} av maks ${this.maxLength} mulige er valgt.
          </div>
        ` : h;
  }
  renderUserMessage() {
    return this.userMessage ? d`<div class="pkt-listbox__banner pkt-listbox__banner--user-message">
          <pkt-icon
            class="pkt-listbox__banner-icon"
            name="exclamation-mark-circle"
            size="large"
          ></pkt-icon>
          ${this.userMessage}
        </div>` : h;
  }
  renderSearch() {
    return this.includeSearch ? d`
          <div class="pkt-listbox__search">
            <span class="pkt-listbox__search-icon">
              <pkt-icon name="magnifying-glass-small" size="large"></pkt-icon>
            </span>
            <input
              class="pkt-txt-16-light"
              type="text"
              aria-label="Søk i listen"
              form=""
              placeholder=${this.searchPlaceholder || _.forms.search.placeholder}
              @input=${this.handleSearchInput}
              @keydown=${this.handleSearchKeydown}
              .value=${this.searchValue}
              data-type="searchbox"
              ?disabled=${this.disabled}
              ?readonly=${this.disabled}
              role="searchbox"
            />
          </div>
        ` : h;
  }
  // Event handlers
  handleSearchInput(e) {
    this.searchValue = e.target.value, this.dispatchEvent(
      new CustomEvent("search", {
        detail: this.searchValue,
        bubbles: !1
      })
    );
  }
  handleSearchKeydown(e) {
    switch (e.key) {
      case "Enter":
        e.preventDefault();
        break;
      case "ArrowUp":
      case "Escape":
        this.closeOptions(), e.preventDefault();
        break;
      case "ArrowDown":
        this.focusFirstOrSelectedOption();
        break;
      case "Tab":
        this.tabClose();
        break;
    }
  }
  handleOptionKeydown(e) {
    const t = e.currentTarget, s = t.dataset.value, i = t.dataset.type, a = t.dataset.selected === "true";
    if (!(!f(this).length && (!this.customUserInput || !this.allowUserInput && this.customUserInput) && i !== "new-option" && i !== "searchbox"))
      switch (e.key) {
        case " ":
        case "Enter":
          this.toggleOption(t), e.preventDefault();
          break;
        case "Backspace":
          s && (a ? this.toggleOption(t) : this.closeOptions()), e.preventDefault();
          break;
        case "Escape":
          this.closeOptions(), e.preventDefault();
          break;
        case "Tab":
          this.tabClose();
          break;
        case "ArrowDown":
          e.altKey ? g(this) : i === "searchbox" || i === "new-option" ? x(this) : E(t), e.preventDefault();
          break;
        case "ArrowUp":
          if (e.altKey)
            x(this);
          else if (t.dataset.index === "0" && this.includeSearch) {
            const l = this.querySelector('[role="searchbox"]');
            l && l.focus();
          } else if (t.dataset.index === "0" && this.customUserInput) {
            const l = this.querySelector('[data-type="new-option"]');
            l && l.focus();
          } else
            T(t, this, this.includeSearch);
          e.preventDefault();
          break;
        case "Home":
          x(this), e.preventDefault();
          break;
        case "End":
          g(this), e.preventDefault();
          break;
        default:
          (e.metaKey || e.ctrlKey) && e.key === "a" && (this.selectAll(), e.preventDefault()), C(e.key) && (this.handleTypeAhead(e.key), e.preventDefault());
          break;
      }
  }
  // Focus management methods (delegates to shared utils)
  focusFirstOrSelectedOption() {
    U(this, {
      disabled: this.disabled,
      allowUserInput: this.allowUserInput,
      customUserInput: this.customUserInput,
      includeSearch: this.includeSearch
    });
  }
  // Event dispatching methods
  toggleOption(e) {
    const t = e instanceof HTMLElement ? e.dataset.disabled : e.disabled;
    if (this.disabled || t) return;
    const s = e instanceof HTMLElement ? e.dataset.value : e.value;
    this.dispatchEvent(
      new CustomEvent("option-toggle", {
        detail: s,
        bubbles: !1
      })
    );
  }
  selectAll() {
    this.dispatchEvent(new CustomEvent("select-all", { bubbles: !1 }));
  }
  closeOptions() {
    this.dispatchEvent(new CustomEvent("close-options", { bubbles: !1 }));
  }
  tabClose() {
    this.dispatchEvent(new CustomEvent("tab-close", { bubbles: !1 }));
  }
  // Filtering and typeahead methods
  filterOptions() {
    this._filteredOptions = I(this.options, this.searchValue);
  }
  handleTypeAhead(e) {
    const t = this.typeahead.append(e), s = f(this), i = M(s, t);
    i >= 0 && u(s[i]);
  }
};
r([
  o({ type: String })
], n.prototype, "id", 2);
r([
  o({ type: String })
], n.prototype, "label", 2);
r([
  o({ type: Array })
], n.prototype, "options", 2);
r([
  o({ type: Boolean, reflect: !0, attribute: "is-open" })
], n.prototype, "isOpen", 2);
r([
  o({ type: Boolean })
], n.prototype, "disabled", 2);
r([
  o({ type: Boolean, attribute: "include-search" })
], n.prototype, "includeSearch", 2);
r([
  o({ type: Boolean, attribute: "is-multi-select" })
], n.prototype, "isMultiSelect", 2);
r([
  o({ type: Boolean, attribute: "allow-user-input" })
], n.prototype, "allowUserInput", 2);
r([
  o({ type: Boolean, attribute: "max-is-reached" })
], n.prototype, "maxIsReached", 2);
r([
  o({ type: String, attribute: "custom-user-input" })
], n.prototype, "customUserInput", 2);
r([
  o({ type: String, attribute: "search-placeholder" })
], n.prototype, "searchPlaceholder", 2);
r([
  o({ type: String, attribute: "search-value" })
], n.prototype, "searchValue", 2);
r([
  o({ type: Number, attribute: "max-length" })
], n.prototype, "maxLength", 2);
r([
  o({ type: String, attribute: "user-message" })
], n.prototype, "userMessage", 2);
r([
  w()
], n.prototype, "_filteredOptions", 2);
n = r([
  O("pkt-listbox")
], n);
export {
  n as P,
  j as a,
  z as b,
  H as c,
  F as f,
  W as g,
  N as i
};
